export enum RowSelection {
  Button = 'button',
  Item = 'item',
  None = 'none',
}
